import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import CONSTANTS from '../../../../constants';
import styles from './ViewUserData.module.css';
import {
	getMonthFormatDate,
	getTimestamp,
} from '../../../../utils/getDate.utils';

const ViewUserData = (props) => {
	const { userData, isRoleData } = props;
	const dateTemplate = (rowData, fieldData) => {
		if (!rowData[`${fieldData.field}`]) return <span></span>;
		const convertedTimestamp = getTimestamp(rowData[`${fieldData.field}`]);
		const date = getMonthFormatDate(convertedTimestamp?.split(' ')[0]);
		const time = convertedTimestamp?.split(' ')[1];
		const ampm = convertedTimestamp?.split(' ')[2];
		return <span>{`${date} ${time} ${ampm}`}</span>;
	};

	const columnArray = isRoleData
		? CONSTANTS.userRoleDetailsColumns
		: CONSTANTS.userDetailsColumns;
	return (
		<div>
			<DataTable
				value={[userData]}
				rowClassName={styles.row}
				className={styles.table}
			>
				{columnArray.map((col) => (
					<Column key={col.field} field={col.field} header={col.header} />
				))}
				<Column
					body={dateTemplate}
					field="creationDate"
					header="Creation Date"
				></Column>
				<Column
					body={dateTemplate}
					field="approvedDate"
					header="Approved Date"
				></Column>
				<Column
					body={dateTemplate}
					field="updationDate"
					header="Updated Date"
				></Column>
			</DataTable>
		</div>
	);
};

export default ViewUserData;
